import React from "react";
import axios from "axios";
import { QRCodeSVG } from "qrcode.react";
import { toast, Toaster } from "sonner";
import { useNavigate, useParams } from "react-router-dom";
import { useDemoSessao, BarraApresentador, FeedEventos, CardFinanceiro, CardMontadora } from "./ApresentacaoParticular";
import { RevisaoShowroom } from "../components/demo/RevisaoShowroom";
import { AvaliacaoShowroom } from "../components/demo/AvaliacaoShowroom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CORES = { finalizado: "text-[#34D399]", ausente: "text-[#FFCC00]", DEMO_ENCERRADA: "text-red-400" };

export function DemoEmpresaEntrar() {
  const { sessao } = useParams();
  const navigate = useNavigate();
  React.useEffect(() => {
    axios.post(`${API}/demo/sessao/${sessao}/login`, { papel: "empresa" })
      .then(r => {
        sessionStorage.setItem("pim_token", r.data.token);
        sessionStorage.setItem("pim_role", r.data.role);
        window.location.href = "/admin";
      })
      .catch(() => navigate(`/apresentacao-empresa`));
  }, [sessao, navigate]);
  return <div className="min-h-screen bg-[#0B1020] text-white flex items-center justify-center">Abrindo Empresa Demo…</div>;
}

export default function ApresentacaoEmpresa() {
  const { sid, estado, criar } = useDemoSessao("empresa");
  React.useEffect(() => { document.title = "MontaJá · Demonstração"; }, []);
  const sess = estado?.sessao;
  const servs = estado?.resumo?.servicos || [];
  const url = sid ? `${window.location.origin}/demo/empresa/${sid}` : "";
  const statusDe = (id) => servs.find(s => s.id === id) || {};

  const c2 = async (acao, body = {}) => {
    try {
      await axios.post(`${API}/demo/sessao/${sid}/cenario/c2/${acao}`, body);
      if (acao === "concluir_retorno") {
        toast.success("Retorno concluído — abrindo o painel real…");
        setTimeout(() => abrirPainel("/admin"), 1200);
      } else { toast.success("Etapa avançada"); }
    }
    catch (e) { toast.error(e?.response?.data?.detail || "Erro"); }
  };
  const abrirPainel = async (rota = "/admin") => {
    try {
      const r = await axios.post(`${API}/demo/sessao/${sid}/login`, { papel: "empresa" });
      sessionStorage.setItem("pim_token", r.data.token);
      sessionStorage.setItem("pim_role", r.data.role);
      window.location.href = rota;
    } catch (e) { toast.error("Erro"); }
  };

  if (sess && sess.status !== "ativa") {
    return (
      <div className="min-h-screen bg-[#0B1020] text-white flex flex-col items-center justify-center gap-6 p-8">
        <div className="text-4xl font-extrabold">Esta demonstração foi encerrada.</div>
        <div className="text-xl text-white/60">Obrigado por conhecer o MontaJá.</div>
        <a href={`${API}/demo/sessao/${sid}/relatorio.pdf`} target="_blank" rel="noreferrer"
          className="px-6 py-3 rounded-xl border border-white/20 font-bold" data-testid="demo-relatorio-final">📄 Baixar Relatório da Apresentação (PDF)</a>
        <button onClick={() => { localStorage.removeItem("demo_sessao_empresa"); criar(); }}
          className="px-6 py-3 rounded-xl bg-[#FF6700] font-bold">Nova Apresentação</button>
      </div>
    );
  }
  return (
    <div className="min-h-screen bg-[#0B1020] text-white pb-20">
      <Toaster richColors />
      <div className="max-w-7xl mx-auto px-6 py-8 grid lg:grid-cols-2 gap-10">
        <div>
          <div className="text-[11px] font-extrabold uppercase tracking-[0.25em] text-[#FF6700]">MontaJá · Showroom</div>
          <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight mt-2">Agora experimente o MontaJá<br />como <span className="text-[#FF6700]">empresa.</span></h1>
          <p className="mt-3 text-white/60 max-w-md">Escaneie para abrir o painel da Bela Móveis (Demo) — importação, distribuição, assistências, pulmão de peças e financeiro. Gestão operacional pela montadora <b className="text-white/80">Ébano e Marfim (Demo)</b>.</p>
          {url && <div className="mt-8 bg-white p-6 rounded-3xl inline-block" data-testid="demo-qr-empresa"><QRCodeSVG value={url} size={240} /></div>}
          <div className="mt-4 flex flex-wrap gap-2">
            <button onClick={() => abrirPainel("/admin")} className="px-4 py-2 rounded-xl bg-[#126BFF] font-bold text-sm" data-testid="demo-abrir-painel">Abrir painel Empresa nesta tela →</button>
            <a href={`${API}/demo/sessao/${sid}/planilha-demo.xlsx`} download
              className="px-4 py-2 rounded-xl border border-[#00A859]/50 text-[#34D399] font-bold text-sm hover:bg-[#00A859]/10"
              data-testid="demo-baixar-planilha">📥 Baixar planilha demo (5 clientes)</a>
          </div>
          <CardFinanceiro fin={estado?.resumo?.financeiro} />
          <CardMontadora mt={estado?.resumo?.montadora} />
          <div className="mt-6 space-y-2" data-testid="demo-clientes">
            <span className="text-[10px] font-extrabold uppercase tracking-widest text-white/40">Os 5 clientes da demonstração</span>
            {(sess?.clientes || []).map(c => {
              const st = statusDe(c.servico_id);
              return (
                <div key={c.n} className="rounded-xl border border-[#126BFF]/25 bg-[#142766]/40 px-4 py-3 flex items-center justify-between" data-testid={`demo-cliente-${c.n}`}>
                  <div>
                    <span className="text-[#FF6700] font-extrabold mr-2">0{c.n}</span>
                    <b>{c.titulo}</b>
                    <span className="ml-2 text-xs text-white/40">{c.pim}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className={`text-xs font-bold ${CORES[st.status] || "text-[#6FA6FF]"}`}>{st.status || "—"}</span>
                    {c.n === 3 && (
                      <button onClick={() => abrirPainel("/admin/pulmao")} className="text-[11px] px-2 py-1 rounded bg-[#126BFF]/15 text-[#6FA6FF] font-bold" data-testid="demo-ver-pulmao">Ver no Pulmão de Peças</button>
                    )}
                    <button onClick={() => abrirPainel(`/admin/servicos/${c.servico_id}`)} className="text-[11px] px-2 py-1 rounded bg-white/5 font-bold">Abrir OS</button>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="mt-5 rounded-2xl border border-[#FFCC00]/30 bg-[#FFCC00]/5 p-4" data-testid="demo-c2-controles">
            <div className="font-bold text-[#FFCC00] text-sm mb-2">Cliente 02 — avançar a Assistência (funções reais)</div>
            <div className="flex flex-wrap gap-1.5">
              {[["peca_solicitada", "Avançar — Peça Solicitada"], ["peca_recebida", "Avançar — Peça Recebida"],
                ["agendar_retorno", "Agendar retorno (mesmo montador)"], ["concluir_retorno", "Concluir retorno"],
                ["avaliar", "Avaliar ⭐5"]].map(([a, l]) => (
                <button key={a} onClick={() => c2(a, a === "avaliar" ? { estrelas: 5 } : {})}
                  className="px-3 py-1.5 rounded-lg bg-[#142766] border border-[#126BFF]/30 text-xs font-bold hover:bg-[#126BFF]/20"
                  data-testid={`demo-c2-${a}`}>{l}</button>
              ))}
            </div>
            <div className="text-[10px] text-white/40 mt-2">Etapas avançam pela máquina de estados real (peça solicitada → recebida → disponível → retorno → concluída). O SLA de 10/20/30 dias é acompanhado pelo job real — chamado aberto há 5 dias.</div>
            <div className="text-[10px] text-white/40 mt-2">A chegada da peça NÃO encerra a assistência — o fluxo segue para o retorno do montador.</div>
          </div>
          <RevisaoShowroom sid={sid} itens={sess?.cenarios_revisao || []} servs={servs} />
          <AvaliacaoShowroom sid={sid} itens={sess?.cenarios_avaliacao || []} avaliacoes={estado?.resumo?.avaliacoes || []} servs={servs} />
        </div>
        <div>
          <div className="flex items-center justify-between mb-3">
            <h2 className="text-lg font-extrabold">O que está acontecendo?</h2>
            <span className="text-[10px] px-2 py-1 rounded bg-[#126BFF]/15 text-[#6FA6FF] font-bold uppercase">{sess?.etapa_atual || "—"}</span>
          </div>
          <FeedEventos eventos={estado?.eventos} />
        </div>
      </div>
      <BarraApresentador sid={sid} tipo="empresa" criar={criar} />
    </div>
  );
}
